import * as R from 'ramda'
import { ofType } from 'redux-observable'
import { empty, of } from 'rxjs'
import { catchError, filter, startWith, switchMap } from 'rxjs/operators'
import { captureException } from 'helpers/raven'
import { isObject } from 'helpers/typeof'
import { getResources } from 'store/reducers/resources.ts'
import * as Actions from 'store/actions/index.ts'
import {
  getCountryCode,
  getCultureCode,
  getIsReviewsFeatureEnabled,
  getProductCoordinates,
  getProductLocationId
} from 'store/selectors'

// type IsReviewsFetchResponseValid = any => boolean
const isReviewsFetchResponseValid = reviews => (
  isObject(reviews) &&
  Boolean(reviews) && Boolean(reviews.ratingsSummary)
)

const isProductFetched = (action) => // (action: ResourceFetchedAction)
  action.payload.type === 'product'

// type OnInvalidReviewsFetchResponse = (string, Object, boolean) => Observable<any> // Observable<FetchProductReviewsErrorAction>
const onInvalidReviewsFetchResponse = (errorMessage, dataToTrack, isSentryEnabled) => {
  if (isSentryEnabled) {
    captureException(new Error('Unable to fetch product reviews'), {
      extra: { errorMessage, ...dataToTrack }
    })
  }

  return of(Actions.reviews.onProductReviewsFetchError(errorMessage))
}

const reviewsEpic = (actions$, state$, { api }) => actions$.pipe(
  ofType(Actions.resources.RESOURCE_FETCHED),
  filter(isProductFetched),

  switchMap(({ payload: { key } }) => {
    const state = state$.value
    const product = getResources(state)[key]
    const displayReviews = R.path(['ecomm', 'displayRatings'], product)
    const enableReviews = getIsReviewsFeatureEnabled(state)
    const mapCoordinates = getProductCoordinates(state)
    const locationId = getProductLocationId(state)
    const shouldFetchReviews = (
      enableReviews &&
      displayReviews &&
      ((mapCoordinates.longitude !== 0 && mapCoordinates.latitude !== 0) || locationId !== undefined)
    )
    const countryCode = getCountryCode(state)
    const cultureCode = getCultureCode(state)

    return shouldFetchReviews && api
      ? api.fetchReviews(mapCoordinates.latitude, mapCoordinates.longitude, locationId, countryCode, cultureCode).pipe(
        switchMap(({ response }) => (
          isReviewsFetchResponseValid(response)
            ? of(Actions.reviews.onProductReviewsFetched(key, response))
            : onInvalidReviewsFetchResponse('Corrupted reviews', { displayReviews, key, latitude: mapCoordinates.latitude, locationId, longitude: mapCoordinates.longitude, shouldFetchReviews }, false)
        )),
        catchError(error => onInvalidReviewsFetchResponse(error.message, { displayReviews, key, latitude: mapCoordinates.latitude, locationId, longitude: mapCoordinates.longitude, shouldFetchReviews }, true)),
        startWith(Actions.fetch.onFetchStarted())
      )
      : empty()
  })
)

export default reviewsEpic
